export default __webpack_public_path__ + "static/media/tunnel5.43dc7a03.jpeg";